import { ComponentType } from 'react';
import { IArticlesConfig } from './config/adapters';

export interface IWithArticlesConfigProps {
  articlesConfig: IArticlesConfig,
}

export const withArticlesConfig = <P extends object>(
  Component: ComponentType<P & IWithArticlesConfigProps>,
  useConfigHook: () => IArticlesConfig,
): ComponentType<P> => {
  return (props: P) => {
    const config = useConfigHook();
    return <Component { ...props } articlesConfig={ config } />;
  };
};
